import React from 'react';

import { I18n } from 'js/components/common/I18n';
import { SvgIcon } from 'js/app/components/common/SvgIcon';

import style from '../JumioPopupUploader.scss';

export const JumioStepStart = ({ translate, setCurrentStep }) =>
    <div>
        <div className={style.welcomeText}>
            <I18n t={translate} tKey='uploader.text' />
        </div>
        <div
            className={style.buttonsHeader}>{ translate('uploader.list-title') }</div>
        <div>
            {[
                { step: 'driving', style: style.iconDriving },
                { step: 'passport', style: style.iconPassport },
                { step: 'id', style: style.iconId },
                { step: 'other', style: style.iconOther }
            ].map((v, i) =>
                <div className={style.button} onClick={() => setCurrentStep(v.step)} key={i}>
                    <span className={v.style} />
                    <span className={style.buttonText}>
                        <I18n t={translate} tKey={`button.${v.step}`} />
                    </span>
                    <SvgIcon type='arrow-right' className={style.rightArrow} />
                </div>
            )}
        </div>
    </div>;
